export default {
  'department.department': 'Abteilung',
  'department.name': 'Abteilungsname',
  'department.perisanname': 'Persischer Abteilungsname',
  'department.englishname': 'Englischer Abteilungsname',
  'department.code': 'Abteilungscode',
  'department.add': 'Abteilung hinzufügen',
  'department.title': 'Abteilungsleitung',
  'department.departmentdel': 'Abteilung löschen',
  'department.departmentadd': 'Abteilung erfolgreich hinzugefügt!',
  'department.departmentdelete': 'Abteilung erfolgreich gelöscht!',
  'department.deleteerror': 'Rekord wurde von anderen  verwendet',
  'department.departmentaddInformation':
    'Ihre Informationen wurden erfolgreich bearbeitet',
};
